export default __webpack_public_path__ + "static/media/Events.cd16f8f4.svg";